module.exports = __webpack_public_path__ + "img/icon11.deda0983.svg";